import { Record } from "immutable";
import { CreatePopulatedBlockRequest } from "models/interfaces/populated-blocks/create-populated-block-request";
import {
    BlockDestinationRecordFactory,
    ExistingPageDestinationRecord,
} from "models/view-models/populated-blocks/block-destination-record";
import {
    ChecklistBlockRecord,
    PopulatedBlockRecordFactory,
} from "models/view-models/populated-blocks/populated-block-record";

const defaultValues: CreatePopulatedBlockRequest = {
    destination: new ExistingPageDestinationRecord(),
    block: new ChecklistBlockRecord(),
};

export class CreatePopulatedBlockRequestRecord
    extends Record(defaultValues)
    implements CreatePopulatedBlockRequest
{
    constructor(params?: Partial<CreatePopulatedBlockRequest>) {
        const values = Object.assign({}, defaultValues, params);

        values.destination = BlockDestinationRecordFactory(values.destination);
        values.block = PopulatedBlockRecordFactory(values.block);

        super(values);
    }

    public with(
        values: Partial<CreatePopulatedBlockRequest>
    ): CreatePopulatedBlockRequestRecord {
        return new CreatePopulatedBlockRequestRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
